<template>
  <RecommendationBlockTemplate :ready="ready" class="contents">
    <template #header>
      <span class="header">
        <span>
          Pour continuer de t’entrainer
          <icon name="nomad:diamond" size="2rem" />
        </span>
        <span class="controls">
          <ScrollHorizontalControl
            @click-scroll-right="handleClickScrollRight"
            @click-scroll-left="handleClickScrollLeft"
          />
        </span>
      </span>
    </template>

    <ul ref="scrollable" class="list">
      <li v-for="(item, index) in recommendedItems" :key="item.id">
        <RecommendationButtonContent
          :recommendation="item"
          :m-media="mMedia"
          :index="index"
        />
      </li>
    </ul>
  </RecommendationBlockTemplate>
</template>
<script setup lang="ts">
interface Props {
  ready: boolean;
}
const props = defineProps({
  ready: { type: Boolean }
});

const scrollable = useTemplateRef('scrollable');

const { recommendedItems, mMedia } = inject(INJECT_RECOMMENDATION);

const handleClickScrollRight = () => {
  scrollable.value.scroll({
    left: scrollable.value.scrollLeft + 200,
    behavior: 'smooth',
  });
};
const handleClickScrollLeft = () => {
  scrollable.value.scroll({
    left: scrollable.value.scrollLeft - 200,
    behavior: 'smooth',
  });
};
</script>
<style lang="scss" scoped>
.contents {
  width: 100%;
  @include above('l') {
    width: calc(3 * 22.4rem + 2 * var(--gap_n));
  }
}
.list {
  display: flex;
  min-width: 0;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-y: visible;
  gap: var(--gap_n);
  scroll-snap-points-x: repeat(100%);
  scroll-snap-type: x mandatory;
  > * {
    scroll-snap-align: start;
  }
  &::-webkit-scrollbar {
    height: 0;
  }
  &::-webkit-scrollbar-thumb,
  &::-webkit-scrollbar-track {
    border-radius: 0;
  }

  &::-webkit-scrollbar-thumb {
    background: var(--color_neutral_60);
  }

  &::-webkit-scrollbar-track {
    background: var(--color_neutral_50);
  }
}

.controls {
  @include mobile {
    display: none;
  }
}

.header {
  display: flex;
  justify-content: space-between;
}
</style>
